import Box from 'v2/components/UI/Box';
import useWaterAnalysisNurseries from './hooks/useWaterAnalysisNurseries';
import Icon from 'v2/components/Icon';
import Text from 'v2/components/UI/Text';
import Select from 'v2/components/Select';
import MultiSelectAll from 'components/MultiSelect';
import LineChart from '../../UI/LineChart';

const WaterAnalysisNurseries = () => {
  const {
    optionsNurseries,
    selectedNurseries,
    optionsnParameters,
    selectedParameters,

    handleChangeParameters,
    setSelectedParameters,
  } = useWaterAnalysisNurseries();

  const renderTextEmptyMessageOrGraph = () => {
    if (optionsNurseries.length === 2 && optionsnParameters.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Nenhum dado encontrado
          </Text>
        </Box>
      );
    }

    if (selectedParameters.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Selecione ao menos um parâmetro
          </Text>
        </Box>
      );
    }

    return <LineChart data={selectedParameters} />;
  };

  return (
    <Box
      flexDirection="column"
      gap={30}
      padding={30}
      background="#fff"
      borderRadius={18}
    >
      <Box gap={10} alignItems="center">
        <Icon iconName="WaterDropOutlined" htmlColor="#005f47" size={30} />
        <Text fontSize={24} fontWeight={700} color="#005f47">
          Análise da Água por Viveiros
        </Text>
      </Box>
      <Box gap={20}>
        <Select
          backgroundColor="#b7ffbd"
          options={optionsNurseries}
          value={selectedNurseries}
          labelId="supplies-label"
          selectId="supplies-id"
          label="Viveiros"
          onChange={handleChangeParameters}
          defaultValue={'default'}
        />

        <Box>
          <MultiSelectAll
            label="Parâmetros"
            id="shrimppond"
            allSelected={
              optionsnParameters?.length === optionsNurseries?.length
            }
            labelOption="name"
            onChange={setSelectedParameters}
            options={optionsnParameters}
            value={selectedParameters}
            error={false}
            helperText={false}
            renderOptionLabel={false}
            labelSelectAllButtonFilterOptions={false}
            labelCustomRenderOption={false}
          />
        </Box>
      </Box>
      {renderTextEmptyMessageOrGraph()}
    </Box>
  );
};

export default WaterAnalysisNurseries;
